import { render, staticRenderFns } from "./pg-updemail.vue?vue&type=template&id=9798ff24&scoped=true"
import script from "./pg-updemail.vue?vue&type=script&lang=js"
export * from "./pg-updemail.vue?vue&type=script&lang=js"
import style1 from "./pg-updemail.vue?vue&type=style&index=1&id=9798ff24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9798ff24",
  null
  
)

export default component.exports